import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mock",
  "use": "icon-mock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-mock\"><path d=\"M959.04 262.4a41.6 41.6 0 0 0-11.776-23.68L784.896 75.776A41.152 41.152 0 0 0 756.16 64H267.584a40.704 40.704 0 0 0-28.672 11.776L75.968 238.72a41.536 41.536 0 0 0-10.88 23.68 36.8 36.8 0 0 0-1.088 5.12v574.848C64 907.392 116.672 960 181.632 960h660.8A117.632 117.632 0 0 0 960 842.432V267.456a40 40 0 0 0-1.088-5.12h0.128zM406.4 826.56L469.12 632.96l-117.632-16.256 273.984-243.904-69.12 198.4 115.456 14.144-265.6 241.28zM195.2 226.688l89.024-93.312h454.912l91.2 93.312H195.2z\" p-id=\"10245\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mock.svg
// module id = 5nc+
// module chunks = 77